// extracted by mini-css-extract-plugin
export default {"Login":"Login_Login__J0zpQ","LoginForm":"Login_LoginForm__IEB11"};